import { Injectable } from '@angular/core';
import { SecurityRequestService } from './security-request.service';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthService } from './auth.service';
import { Claim } from '../model/claim.model';

@Injectable({
  providedIn: 'root'
})
export class AuthorizationService {

  constructor(
    private securityRequestService: SecurityRequestService,
    private authService: AuthService
  ) { }

  public selectCompany(idCompany: string) {
    let _payload = { 
      Value: idCompany
    }
    this.securityRequestService.post(`${environment.bffApi}/Authorization/select-company`, _payload).subscribe(
      response => {

        if(response.Success){
          var _data = localStorage.getItem("claims");

          if (_data == null)
            return;

          let _claim: Claim = JSON.parse(_data);
          _claim.IdCompanySelected = response.Data.IdCompanySelected;

          localStorage.setItem('claims', JSON.stringify(_claim));
          this.authService.valueSelected.next(_claim);
        }          
      }
    );
  }

  public selectLineOfProduct(idLineOfProduct: string) {
    let _payload = { 
      Value: idLineOfProduct
    }
    this.securityRequestService.post(`${environment.bffApi}/Authorization/select-lineofproduct`, _payload).subscribe(
      response => {

        if(response.Success){
          var _data = localStorage.getItem("claims");

          if (_data == null)
            return;

          let _claim: Claim = JSON.parse(_data);
          _claim.IdLineOfProductSelected = response.Data.IdLineOfProductSelected;

          localStorage.setItem('claims', JSON.stringify(_claim));
          this.authService.valueSelected.next(_claim);
        }          
      }
    );
  }
}
